import { AxiosResponse } from 'axios';
import { pureFinalPropsSelectorFactory } from 'react-redux/es/connect/selectorFactory';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { ResponseBase } from 'src/app/models/response-base';
import { CollaboratorsPurchaseRequest } from '../../models/purchase/collaborators-purchase-request.model';
import { CreatePurchaseRequest } from '../../models/purchase/create-purchase-request.model';
import { PaymentPurchaseRequest } from '../../models/purchase/payment-purchase-request.model';
import { PaymentPurchaseResponse } from '../../models/purchase/payment-purchase-response.model';
import { PurchaseSummary } from '../../models/purchase/summary-purchase.model';
import { ValuesPurchaseRequest } from '../../models/purchase/values-purchase-request.model';
import { api } from '../../services/api';
import { resetPurchaseCollaborator, summaryOldValueRebalance } from '../collaborator/actions';
import { ADD_COLLABORATOR_PURCHASE, CREATE_PURCHASE, GET_PURCHASE_SUMMARY, PAYMENT_PURCHASE, RESET_PURCHASE, UPDATE_VALUES_PURCHASE } from '../contants';
import { addCollaboratorsPurchaseError, addCollaboratorsPurchaseSuccess, paymentPurchaseError, paymentPurchaseSuccess, updateValuesPurchaseError, updateValuesPurchaseSuccess } from '../purchase/actions';
import { createPurchaseError, createPurchaseSuccess, getPurchaseSummaryError, getPurchaseSummarySuccess, resetPurchaseError, resetPurchaseSuccess } from './actions';

type createPurchasePayload = { assignorGuid: string, managerGuid: string, createPurchase: CreatePurchaseRequest }
type createPurchaseParams = { payload: createPurchasePayload, type: string };

type addCollaboratorsPurchasePayload = { assignorGuid: string, managerGuid: string, collaboratorsPurchase: CollaboratorsPurchaseRequest }
type addCollaboratorsPurchaseParams = { payload: addCollaboratorsPurchasePayload, type: string };

type updateValuesPurchasePayload = { assignorGuid: string, managerGuid: string, valuesPurchase: ValuesPurchaseRequest }
type updateValuesPurchaseParams = { payload: updateValuesPurchasePayload, type: string };

type fetchPurchaseSummaryPayload = { assignorGuid: string, managerGuid: string, purchaseId: number, productId: number, oldValue: number, newValue: number, purchaseSummary?: PurchaseSummary};
type fetchPurchaseSummaryParams = { payload: fetchPurchaseSummaryPayload, type: string };

type paymentPurchasePayload = { assignorGuid: string, managerGuid: string, purchaseId: number, paymentPurchase: PaymentPurchaseRequest};
type paymentPurchaseParams = { payload: paymentPurchasePayload, type: string };

export function* watchResetPurchase() {
  yield takeEvery(RESET_PURCHASE, resetPurchase);
}

function* resetPurchase() {
  try {
    yield put(resetPurchaseSuccess());
    yield put(resetPurchaseCollaborator());
  } catch (error) {
    yield put(resetPurchaseError(error));
  }
}

export function* watchCreatePurchase() {
  yield takeEvery(CREATE_PURCHASE, createPurchase);
}

const createPurchaseAsync = async (assignorGuid: string, managerGuid: string, createPurchase: CreatePurchaseRequest) =>
  await api.post(`purchases/assignors/${assignorGuid}/managers/${managerGuid}`, createPurchase)
    .then((response: any) => response)
    .catch((error: any) => error);


function* createPurchase({ payload }: createPurchaseParams) {
  try {
    const { assignorGuid, managerGuid, createPurchase } = payload;
    const response: AxiosResponse<ResponseBase<number>> = yield call(createPurchaseAsync, assignorGuid, managerGuid, createPurchase);

    if (response?.data?.status == 1) {
      yield put(createPurchaseSuccess(response?.data?.result));
    } else {
      yield put(createPurchaseError(response?.data?.message));
    }
  } catch (error) {
    yield put(createPurchaseError(error));
  }
}

export function* watchAddCollaboratorsPurchase() {
  yield takeEvery(ADD_COLLABORATOR_PURCHASE, addCollaboratorsPurchase);
}

const addCollaboratorsPurchaseAsync = async (assignorGuid: string, managerGuid: string, collaboratorsPurchase: CollaboratorsPurchaseRequest) =>
  await api.put(`purchases/assignors/${assignorGuid}/managers/${managerGuid}/collaborators`, collaboratorsPurchase)
      .then((response: any) => response)
      .catch((error: any) => error);


  function* addCollaboratorsPurchase({ payload }: addCollaboratorsPurchaseParams) {
  try {
      const { assignorGuid, managerGuid, collaboratorsPurchase } = payload;
      const response: AxiosResponse<ResponseBase<boolean>> = yield call(addCollaboratorsPurchaseAsync, assignorGuid, managerGuid, collaboratorsPurchase);

      if (response?.data?.status == 1) {
      yield put(addCollaboratorsPurchaseSuccess(response?.data?.result));
      } else {
      yield put(addCollaboratorsPurchaseError(response?.data?.message));
      }
  } catch (error) {
      yield put(addCollaboratorsPurchaseError(error));
  }
}

export function* watchUpdateValuesPurchase() {
  yield takeEvery(UPDATE_VALUES_PURCHASE, updateValuesPurchase);
}

const updateValuesPurchaseAsync = async (assignorGuid: string, managerGuid: string, valuesPurchase: ValuesPurchaseRequest) =>
  await api.put(`purchases/assignors/${assignorGuid}/managers/${managerGuid}/values`, valuesPurchase)
    .then((response: any) => response)
    .catch((error: any) => error);

function* updateValuesPurchase({ payload }: updateValuesPurchaseParams) {
  try {
    const { assignorGuid, managerGuid, valuesPurchase } = payload;
    const response: AxiosResponse<ResponseBase<any>> = yield call(updateValuesPurchaseAsync, assignorGuid, managerGuid, valuesPurchase);

    if (response?.data?.status === 1) {
      yield put(updateValuesPurchaseSuccess(response?.data?.result));
    } else {
      yield put(updateValuesPurchaseError(response?.data?.message));
    }
  } catch (error) {
    yield put(updateValuesPurchaseError(error));
  }
}

export function* watchFetchPurchaseSummary() {
  yield takeEvery(GET_PURCHASE_SUMMARY, fetchPurchaseSummary);
}

const fetchPurchaseSummaryAsync = async (assignorGuid: string, managerGuid: string, purchaseId: number, params: any, purchaseSummary?: any) =>
  await api.post(`purchases/assignors/${assignorGuid}/managers/${managerGuid}/purchase/${purchaseId}/summary`, purchaseSummary, { params })
    .then((response: any) => response)
    .catch((error: any) => error);


function* fetchPurchaseSummary({ payload }: fetchPurchaseSummaryParams) {
  try {
    const { assignorGuid, managerGuid, purchaseId, productId, oldValue, newValue, purchaseSummary } = payload;

    const params = new URLSearchParams(
      [
        ['productId', productId.toString() ],
        ['oldValue', oldValue.toString() ],
        ['newValue', newValue.toString() ]
      ]
    );

    const response: AxiosResponse<ResponseBase<PurchaseSummary>> = yield call(fetchPurchaseSummaryAsync, assignorGuid, managerGuid, purchaseId, params, purchaseSummary);

    if (response?.data?.status == 1) {
      yield put(getPurchaseSummarySuccess(response?.data?.result));
    } else {
      yield put(getPurchaseSummaryError(response?.data?.message));
    }
  } catch (error) {
    yield put(getPurchaseSummaryError(error));
  }
}

export function* watchPaymentPurchase() {
    yield takeEvery(PAYMENT_PURCHASE, paymentPurchase);
  }

  const paymentPurchaseAsync = async (assignorGuid: string, managerGuid: string, purchaseId: number, paymentPurchase: PaymentPurchaseRequest) =>
    await api.post(`purchases/${purchaseId}/assignors/${assignorGuid}/managers/${managerGuid}/finish`, paymentPurchase)
      .then((response: any) => response)
      .catch((error: any) => error);


  function* paymentPurchase({ payload }: paymentPurchaseParams) {
    try {
      const { assignorGuid, managerGuid, purchaseId, paymentPurchase } = payload;

      const response: AxiosResponse<ResponseBase<PaymentPurchaseResponse>> = yield call(paymentPurchaseAsync, assignorGuid, managerGuid, purchaseId, paymentPurchase);

      if (response?.data?.status == 1) {
        yield put(paymentPurchaseSuccess(response?.data?.result));
      } else {
        yield put(paymentPurchaseError(response?.data?.message));
      }
    } catch (error) {
      yield put(paymentPurchaseError(error));
    }
  }


export default function* rootSaga() {
  yield all([
    fork(watchCreatePurchase),
    fork(watchAddCollaboratorsPurchase),
    fork(watchUpdateValuesPurchase),
    fork(watchFetchPurchaseSummary),
    fork(watchPaymentPurchase),
    fork(watchResetPurchase)
  ]);
}
